var n = /* @__PURE__ */ ((r) => (r[r.EMPORIUM = 0] = "EMPORIUM", r[r.INVENTORY = 1] = "INVENTORY", r[r.OTHERS_INVENTORY = 2] = "OTHERS_INVENTORY", r[r.FAVORITE = 3] = "FAVORITE", r[r.POPUP_SELECT_INVENTORY = 4] = "POPUP_SELECT_INVENTORY", r))(n || {}), a = /* @__PURE__ */ ((r) => (r.Reserved = "Reserved", r.Minted = "Minted", r))(a || {}), i = /* @__PURE__ */ ((r) => (r[r.Unknown = 0] = "Unknown", r[r.Empty = 1] = "Empty", r[r.Locked = 2] = "Locked", r[r.Reserved = 3] = "Reserved", r))(i || {}), d = /* @__PURE__ */ ((r) => (r.Origin = "origin", r.Season = "season", r.Unknown = "unknown", r))(d || {}), _ = /* @__PURE__ */ ((r) => (r.None = "TicketMintTypeNone", r.Origin = "TicketOrigin", r.S2Golden = "TicketS2GoldenApostle", r.S2 = "TicketS2Apostle", r.S2RGolden = "TicketS2RGoldenApostle", r.S2R = "TicketS2RApostle", r.ZombieSummon = "TicketZombieSummoner", r))(_ || {}), e = /* @__PURE__ */ ((r) => (r.Bard = "Bard", r.Berserker = "Berserker", r.Dragoon = "Dragoon", r.Guardian = "Guardian", r.Hunter = "Hunter", r.Knight = "Knight", r.Mage = "Mage", r.Priest = "Priest", r.Rogue = "Rogue", r.Shaman = "Shaman", r.Summoner = "Summoner", r.Warrior = "Warrior", r))(e || {}), m = /* @__PURE__ */ ((r) => (r[r.Warrior = 1] = "Warrior", r[r.Guardian = 2] = "Guardian", r[r.Rogue = 3] = "Rogue", r[r.Berserker = 4] = "Berserker", r[r.Knight = 5] = "Knight", r[r.Hunter = 6] = "Hunter", r[r.Mage = 7] = "Mage", r[r.Summoner = 8] = "Summoner", r[r.Dragoon = 9] = "Dragoon", r[r.Bard = 10] = "Bard", r[r.Priest = 11] = "Priest", r[r.Shaman = 12] = "Shaman", r))(m || {}), u = /* @__PURE__ */ ((r) => (r.Enable = "Enable", r.Staked = "Staked", r.Disable = "Disable", r))(u || {}), G = /* @__PURE__ */ ((r) => (r.Bard = "Bard", r.Berserker = "Berserker", r.Dragoon = "Dragoon", r.Guardian = "Guardian", r.Hunter = "Hunter", r.Knight = "Knight", r.Mage = "Mage", r.Priest = "Priest", r.Rogue = "Rogue", r.Shaman = "Shaman", r.Summoner = "Summoner", r.Warrior = "Warrior", r.S2Normal = "S2_Normal", r.S2Golden = "S2_Golden", r.S2RNormal = "S2R_Normal", r.S2RGolden = "S2R_Golden", r.ZombieSummoner = "Zombie_Summoner", r.GoldenGuardian = "Golden_Guardian", r.GoldenWarrior = "Golden_Warrior", r.GoldenRogue = "Golden_Rogue", r.GoldenHunter = "Golden_Hunter", r.GoldenMage = "Golden_Mage", r.GoldenPriest = "Golden_Priest", r.GoldenSummoner = "Golden_Summoner", r.GoldenBard = "Golden_Bard", r.GoldenBerserker = "Golden_Berserker", r.GoldenDragoon = "Golden_Dragoon", r.GoldenShaman = "Golden_Shaman", r.GoldenKnight = "Golden_Knight", r.GoldenApostleTicket = "Golden_Apostle_Ticket", r.ApostleTicket = "Apostle_Ticket", r))(G || {}), D = /* @__PURE__ */ ((r) => (r.Enable = "Enable", r.Staked = "Staked", r.Disable = "Disable", r))(D || {});
const o = ["10001", "10002", "10003"];
var g = /* @__PURE__ */ ((r) => (r.AutoAttack = "Auto Attack", r.Innate = "Energized skill", r.ActiveSkill = "Active skill", r))(g || {}), c = /* @__PURE__ */ ((r) => (r.AutoAttack = "99", r.Innate = "00", r))(c || {}), v = /* @__PURE__ */ ((r) => (r.IDDesc = "IDDesc", r.IDAsc = "IDAsc", r.PriceDesc = "PriceDesc", r.PriceAsc = "PriceAsc", r.ListAtDesc = "ListingTimeDesc", r.UpdateAtDesc = "UpdateAtDesc", r.ApostleIVAsc = "ApostleIVAsc", r.ApostleIVDesc = "ApostleIVDesc", r))(v || {});
const N = [
  {
    id: 0,
    nameId: "list.sort_price_asc",
    value: "PriceAsc"
    /* PriceAsc */
  },
  {
    id: 1,
    nameId: "list.sort_price_desc",
    value: "PriceDesc"
    /* PriceDesc */
  },
  {
    id: 2,
    nameId: "list.sort_id_asc",
    value: "IDAsc"
    /* IDAsc */
  },
  {
    id: 3,
    nameId: "list.sort_id_desc",
    value: "IDDesc"
    /* IDDesc */
  },
  {
    id: 4,
    nameId: "list.sort_apostle_iv_asc",
    value: "ApostleIVAsc"
    /* ApostleIVAsc */
  },
  {
    id: 5,
    nameId: "list.sort_apostle_iv_desc",
    value: "ApostleIVDesc"
    /* ApostleIVDesc */
  },
  {
    id: 6,
    // latest
    nameId: "list.sort_updated_at_desc",
    value: "UpdateAtDesc"
    /* UpdateAtDesc */
  }
], P = [
  {
    id: 0,
    nameId: "list.sort_price_asc",
    value: "PriceAsc"
    /* PriceAsc */
  },
  {
    id: 1,
    nameId: "list.sort_price_desc",
    value: "PriceDesc"
    /* PriceDesc */
  },
  {
    id: 2,
    nameId: "list.sort_id_asc",
    value: "IDAsc"
    /* IDAsc */
  },
  {
    id: 3,
    nameId: "list.sort_id_desc",
    value: "IDDesc"
    /* IDDesc */
  },
  {
    id: 4,
    nameId: "list.sort_apostle_iv_asc",
    value: "ApostleIVAsc"
    /* ApostleIVAsc */
  },
  {
    id: 5,
    nameId: "list.sort_apostle_iv_desc",
    value: "ApostleIVDesc"
    /* ApostleIVDesc */
  },
  {
    id: 6,
    // latest
    nameId: "list.sort_list_at_desc",
    value: "ListingTimeDesc"
    /* ListAtDesc */
  }
];
var E = /* @__PURE__ */ ((r) => (r.TicketMintTypeNone = "TicketMintTypeNone", r.TicketOrigin = "TicketOrigin", r.TicketS2GoldenApostle = "TicketS2GoldenApostle", r.TicketS2Apostle = "TicketS2Apostle", r.TicketZombieSummoner = "TicketZombieSummoner", r))(E || {}), R = /* @__PURE__ */ ((r) => (r.Burn = "Burn", r.BurnAsReservedApostle = "BurnAsReservedApostle", r.Mint = "Mint", r.None = "None", r.Reforge = "Reforge", r.UpdateGene = "UpdateGene", r))(R || {});
const O = "doodle-item-tooltip-id", I = 20, S = -1, V = "RAC";
export {
  V as APOSTLE_CYCLE_BACKEND_NAME,
  R as ApostleAttachAction,
  m as ApostleClassId,
  e as ApostleClassType,
  P as ApostleEmporiumSortItems,
  n as ApostleListMode,
  N as ApostleNormalSortItems,
  c as ApostleSkillSpecialId,
  g as ApostleSkillType,
  v as ApostleSortBy,
  _ as ApostleSourceType,
  u as ApostleStatus,
  d as ApostleTicketItemType,
  D as ApostleTicketStatus,
  G as ApostleTicketType,
  O as DOODLE_ITEM_TOOLTIP_ID,
  I as MAX_APOSTLE_NAME,
  S as NO_REPLACE_INDEX,
  i as ReservedApostleSlotState,
  a as ReservedApostleState,
  o as S2TIcketIDs,
  E as TicketMintEnum
};
//# sourceMappingURL=apostle.js.map
